export const siteSettings = {
  name: "Stratoex Market",
  link: "https://stratoexmarkets.com",
  email: "support@stratoexmarkets.com",
  appLink: "https://app.stratoexmarkets.com",
};
